<nb-card>
  <nb-card-body class="product-item">
    <div class="product-item-content">
      <p-carousel [value]="productImages" [autoplayInterval]="5000" [circular]="productImages.length > 1">
        <ng-template ngbSlide let-item pTemplate="item" class="image-item">
          <img [src]="item" alt="" class="product-image">
        </ng-template>
      </p-carousel>
    </div>
  </nb-card-body>
</nb-card>